import { useState } from 'react';
import { DataGrid } from './dataGrid'

export function getNumericInputBox(curClass = "num-recs", curName = "num-recs", curValue, curType = "number", curChangeFunction) {
    return <input class={curClass} type={curType} name={curName} value={curValue} onChange={(event) => curChangeFunction(event.target.value)}></input>;
}

export function GoButton(total = 10, numInvalid = 5, initBrandFilter = "", refetch) {
    let retVal = {};
    const [numRecsInputValue, setNumRecsInputValue] = useState(total);
    const [invalidInputValue, setinvalidInputValue] = useState(numInvalid);
    const [filterValue, setFilterValue] = useState(initBrandFilter);
    const [rowData, setRowData] = useState([]);

    function ButtonClicked(event) {
        let total = 10;
        let numInvalid = 5;
        let brandFilter = ""

        try {
            total = parseInt(numRecsInputValue);
            numInvalid = parseInt(invalidInputValue);
            brandFilter = filterValue.toLowerCase();
        } catch(e) {
            console.log("Parse Int error", JSON.stringify(e));
            total = 10;
            numInvalid = 5;
            brandFilter = '';
        }

        setNumRecsInputValue(total);
        setinvalidInputValue(numInvalid);
        setFilterValue(brandFilter);

        refetch({ num_recs: total, num_invalid: numInvalid, brand_filter: brandFilter });

        event.target.innerText = 'Go'
    }

    var curGrid = DataGrid(rowData, ButtonClicked);

    retVal.goButton = <button class="go-button" type="submit" value="Go" onClick={ButtonClicked}>Go</button >;
    retVal.numRecs = getNumericInputBox("num-recs", "num-recs", numRecsInputValue, "number", setNumRecsInputValue, 100);
    retVal.numInvalid = getNumericInputBox("num-invalid", "num-invalid", invalidInputValue, "number", setinvalidInputValue, 5);
    retVal.filter = getNumericInputBox("filter", "filter", filterValue, "text", setFilterValue);
    retVal.rowData = rowData;
    retVal.setRowData = setRowData;

    return retVal;
}

